import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../../common/utils';
import { FailedMessagesProfileListFacade } from './failed-messages-profile-list.facade';

@Injectable({
  providedIn: 'root',
})
export class FailedMessagesProfileListGuard {
  constructor(private failedMessagesProfileListFacade: FailedMessagesProfileListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.failedMessagesProfileListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.failedMessagesProfileListFacade);
  }
}
